import { useMutation, useQuery } from '@tanstack/react-query';
import { ImageUploadSessionApi } from './api';
import type { CreateImageUploadSessionDto } from './types';

export function useCreateImageUploadSession(orgId: string) {
  return useMutation({
    mutationFn: (dto: CreateImageUploadSessionDto) =>
      ImageUploadSessionApi.create(orgId, dto),
  });
}

export function usePollImageUploadSession(
  orgId: string,
  sessionId: string | null,
  enabled: boolean
) {
  return useQuery({
    queryKey: ['image-upload-session', orgId, sessionId],
    queryFn: () => ImageUploadSessionApi.get(orgId, sessionId!),
    enabled: enabled && !!sessionId,
    refetchInterval: (query) => {
      const data = query.state.data;
      // Stop polling when image_url is set or session expired
      if (data?.image_url || data?.expired) return false;
      return 5000;
    },
  });
}
